// Dependencies
import styled from 'styled-components';

// Components
import { UserMenu } from '../UserMenu';

export const Container = styled.header`
  display: flex;
  padding: ${({ theme }) => theme.spacing.s}
    ${({ theme }) => `${theme.spaces.xl + 0.8}rem`};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadows.header};
  gap: ${({ theme }) => `${theme.spaces.xxxl + 1.2}rem`};
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
  max-height: ${({ theme }) => theme.sizes.headerMaxHeight};
  position: relative;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.l};
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => `${theme.spaces.m + 0.3}rem`};
  }
`;

export const ContainerMenuLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => `${theme.spaces.s + 0.3}rem`};
`;

export const Logo = styled.img`
  width: ${({ theme }) => theme.sizes.logoWidth};
  height: ${({ theme }) => theme.sizes.logoHeight};
  vertical-align: middle;
`;

export const MenuUser = styled(UserMenu)`
  width: max-content;
`;

export const IconBurguerMenu = styled.img`
  width: ${({ theme }) => theme.sizes.iconSize};
  height: ${({ theme }) => theme.sizes.iconSize};
`;
